export default {
  MEGA: 1900,
  WIDE: 1500,
  LAPTOP: 1200,
  DESKTOP: 992,
  TABLET: 768,
  PHONE: 394,
};
